/**
 * Where signing in returns a person: the page `RequireAuth` sent them from —
 * a deep link, a consent page an application opened (docs/44) — or
 * `fallback`. Only a path of this app is ever followed: anything that is not
 * one (`//elsewhere`, a full address) is the fallback, so a crafted link can
 * never use the sign-in page to send somebody to another site.
 */
export function returnTo(state: unknown, fallback: string): string {
  const from = (state as { from?: unknown } | null)?.from;
  if (typeof from !== 'string' || !from.startsWith('/')) return fallback;
  // A second slash, or a backslash a browser reads as one, names another host.
  if (from.startsWith('//') || from.startsWith('/\\')) return fallback;
  return from;
}
